import React, { useState, Component } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import CommonAlert from '../common/Commonalert';
import { BaseUrl } from '../common/config';
import Loader from '../common/loader';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    const queryParameters = window.location.pathname.split('/');
    this.state = {
      newpassword: "",
      confirmpassword: "",
      loginStatus: "",
      loginMessage: "",
      isLoading: false,
      token:queryParameters['2'],
      userId: queryParameters['3'],
      alertPopup:false,
    };

    this.newPassword = this.newPassword.bind(this);
    this.passwordChange = this.passwordChange.bind(this);

  }

  componentDidMount() {
  }


  validateEmail($email) {
    var emailRegex = /^[a-zA-Z0-9.]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,4}/;
    if (!emailRegex.test($email)) {
      return false;
    } else {
      return true;
    }
  }

  newPassword(event) {
    this.setState({
      newpassword: event.target.value
    });
    this.setState({ loginStatus: "", loginMessage: "", alertPopup: false});
  }

  passwordChange(event) {
    this.setState({
      confirmpassword: event.target.value
    });
    this.setState({ loginStatus: "", loginMessage: "", alertPopup:false });
  }

  resetOnSubmit = (event) => {
    event.preventDefault();
    this.setState({ alertPopup:false });
    let URL = BaseUrl + "resetpassword";
    if (this.state.confirmpassword === this.state.newpassword) {
      let payload = {
        userId: this.state.userId,
        token: this.state.token,
        password: this.state.confirmpassword,

      }
      this.setState({ isLoading: true });
      
      var loginDetails = {};
      if (localStorage.getItem('authData')) {
          loginDetails = JSON.parse(localStorage.getItem('authData'));
      }    
      
      axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
        if (response.data.success === true) {
            this.setState({alertPopup:true, loginMessage: 'Password Reset Successfully'});
             window.location = '/login';
        }
        this.setState({ isLoading: false });
      }).catch((error) => {
      if (error.response.status === 400){
        this.setState({ loginMessage: error.response.data.message, alertPopup:true, isLoading: false });
      }else{

       this.setState({ isLoading: false, alertPopup:false });
      }
      })
    }
    else {
      this.setState({ loginStatus: 401, alertPopup:false });
      this.setState({ loginMessage: "Password doesn't match", alertPopup:false });
    }

  }

  render() {

    return (
      <>
       {this.state.alertPopup === true && ( <CommonAlert title='Alert' message={this.state.loginMessage}/> )}
        <Header />
        { !this.state.isLoading && <div className="login">
          <div className="form">
            <form className="login-form" onSubmit={this.resetOnSubmit}>
              <h2>Reset Password</h2>
              {(this.state.loginStatus) ? (this.state.loginStatus === 401 ? <p className='err-msg'>{this.state.loginMessage}</p> : "") : ""}
              <input type="password" id="accountEmail" value={this.state.password} placeholder="New Password" required onChange={this.newPassword} />
                   <input type="password" id="accountEmail" value={this.state.confirmpassword} placeholder="Confirm Password" required onChange={this.passwordChange} />
              <button type='submit'>Submit</button>
            </form>

          </div>
        </div>
        }
        {this.state.isLoading && <Loader propsClassName="load-lag" />}
   
        <Footer />
      </>
    )
  }
}



export default ResetPassword;